import PropTypes from 'prop-types';
import React from 'react';

const ClaimDetailsHeader = props => (
    <div className="back-to-srcresult">
        <div>
            <h2 className="page-header">
                {props.selectedClaimNumber}
            </h2>
        </div>

        <div>
            <button type="button" className="btn-link" onClick={props.onBackToResult}>
                <i className="fa fa-long-arrow-left" />
                <span> Back to Result</span>
            </button>
        </div>

        <div className="pull-right">
            <span className="printer-icon" onClick={props.handlePrintClick}>
                <i className="fa fa-print" />
            </span>

            <button
                className="primary-button"
                disabled={props.claimDetailsInfo.displayedClaimIndex === 0}
                onClick={props.getPreviousClaimDetails}
                type="button"
            >
                <i className="fa fa-angle-double-left" />
                <span> Prev </span>
            </button>

            <span className="records-info">
                {props.claimDetailsInfo.displayedClaimIndex + 1}
                {' '}
                /
                {' '}
                {props.claimDetailsInfo.totalClaims}
                {' '}
            </span>

            <button className="primary-button" disabled={( props.claimDetailsInfo.displayedClaimIndex + 1 ) === props.claimDetailsInfo.totalClaims} onClick={props.getNextClaimDetails} type="button">
                <span>Next </span>
                <i className="fa fa-angle-double-right" />
            </button>
        </div>
    </div>
);
ClaimDetailsHeader.displayName = 'ClaimDetailsHeader';
ClaimDetailsHeader.propTypes = {
    claimDetailsInfo: PropTypes.object.isRequired,
    onBackToResult: PropTypes.func.isRequired,
    getNextClaimDetails: PropTypes.func.isRequired,
    getPreviousClaimDetails: PropTypes.func.isRequired,
    selectedClaimNumber: PropTypes.string.isRequired,
    callFrom: PropTypes.string.isRequired,
    handlePrintClick: PropTypes.func.isRequired,
};
export default ClaimDetailsHeader;
